var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "MuiChip-icon MuiChip-iconMedium MuiChip-iconColorSecondary",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.258 1.687L8.439.5l2.182 1.187.005 3.285-2.18.367-2.188-.37V1.687z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.307 3.083l2.41.69V5.43l1.656.28-1.647.185v4.25l1.653.195-1.653.31v1.695l-2.419.627v-.008l-.807-.37V3.469l.807-.37v-.016zM11.166 10.65v2.047l2.304.272 1.03-.594V3.688l-1.03-.594-2.306.272.003 2.068-1.645.277 1.644.184v4.25l-1.651.195 1.651.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.267 11.103l2.182-.409 2.177.41v3.22L8.446 15.5l-2.18-1.176v-3.22zM6.267 6.383l2.18-.244 2.179.244V9.66l-2.18.257-2.18-.257V6.383z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s3.918f031db260e2b49692cea5c54ee8bc.svg";
export { ForwardRef as ReactComponent };